export enum ButtonType {
  Primary = 'Primary',
  Secondary = 'Secondary',
  TextButton = 'TextButton',
  Loading = 'Loading',
}
